<template>
  <template class="flex text-menu-link font-medium">
    <!-- pb-4.5/-mb-4.5 stretch the link down to the header's bottom edge (the menu row's pb-2 plus the header's py-2.5)
         without moving anything, so the space above the underline is clickable too. The underline sits at its bottom. -->
    <RouterLink v-if="item.to" class="group relative block w-full pb-4.5 -mb-4.5" :to="computedTo">
      <span class="flex gap-1">
        <span
          v-if="$t(`${label}`) === $t('Competitions') && item?.number_events && item?.number_events !== 0"
          class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base"
          >{{ $t(item.label) }}</span
        >
        <span
          v-else-if="$t(`${label}`) !== $t('Competitions')"
          class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base"
          >{{ $t(item.label) }}</span
        >
      </span>
      <span
        class="absolute bottom-0 inset-x-0 h-[5px] bg-current"
        :class="highlight() ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'" />
    </RouterLink>
    <a v-else-if="item.href" class="group relative block w-full pb-4.5 -mb-4.5" :href="item.href">
      <span class="flex gap-1">
        <span class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base">{{ item.label }}</span>
      </span>
      <span
        class="absolute bottom-0 inset-x-0 h-[5px] bg-current"
        :class="highlightAnchor() ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'" />
    </a>
  </template>
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const { item, label } = defineProps({
  item: Object,
  label: { required: false },
});

const highlight = () => {
  if (
    (!route.fullPath.includes("events") && route.fullPath.includes(item.to)) ||
    (!route.query.sport_type && !route.query.tournament && route.matched.some(({ path }) => path === item.to)) ||
    (!!route.query.sport_type && route.query.sport_type === `${item.label.toLowerCase()}`) ||
    (item.to === "/motorsport/formula-1" && route.fullPath.includes("/events?sport_type=formula1")) ||
    (route.fullPath === "/events?tournament=motogp-2024" && `${item.label.toLowerCase()}` === "motogp") ||
    (route.query.origin === "allevents" && item.label === "All events")
  ) {
    return "underline";
  }
};

const computedTo = computed(() => {
  const [path, rawQuery] = item.to.split("?");
  const existingQuery = new URLSearchParams(rawQuery);
  existingQuery.set("origin", item.label.replace(/\s/g, "").toLowerCase());

  return {
    path,
    query: Object.fromEntries(existingQuery.entries()),
  };
});
const highlightAnchor = () => {
  if (route.matched.some(({ path }) => path === item.to)) {
    return "underline";
  }
};

const route = useRoute();
</script>
